import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiRobotOutline } from '@mdi/js';
import styles from './chatFloatingButton.module.scss';
import { images } from '../../../../constants/images';

interface ChatFloatingButtonProps {
    onClick: () => void;
    isOpen?: boolean;
}

const isPublicationPage = (pathname: string): boolean => {
    return /\/(publication|publicacion)\//.test(pathname) ||
        /\/autos\/(usados|nuevos)\//.test(pathname);
};

const ChatFloatingButton: React.FC<ChatFloatingButtonProps> = ({ onClick, isOpen }) => {
    const location = useLocation();
    const onPublication = isPublicationPage(location.pathname);

    if (isOpen) return null;

    return (
        <button
            className={`${styles.floatingButton} ${onPublication ? styles.onPublication : ''}`}
            onClick={onClick}
            aria-label="Abrir chat con Linze IA"
        >
            <a className={styles.title}>IA</a>
            {/* <Icon path={mdiRobotOutline} size={1.2} /> */}
            {/* <span className={styles.badge}>IA</span> */}
            <img src={images.chatSparkle} alt="Sparkle" className={styles.sparkle} />

        </button>
    );
};

export default ChatFloatingButton;
